/**
 * UserRoute — guards lawyer pages; redirects to /login if not authenticated.
 *
 * NOTE: thanks to the synchronous fast-path in UserAuthContext (loading
 * starts as `false` when no token exists), the `loading` branch only ever
 * shows during a genuine in-flight `/auth/me` call. We render an empty
 * placeholder there — no jarring "جاري التحقق…" white flash.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserAuthContext";

export default function UserRoute({ children }) {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    // Quiet, full-bleed placeholder matching the app's neutral background.
    // No spinner / no text — the wait is < 200ms in practice.
    return <div className="fixed inset-0 bg-[#E4E4E4]" aria-hidden="true" />;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
